;(() => {
  const retailersTemplate = document.querySelector('section.retailers')

  if (retailersTemplate) {
    const ITEMS_TO_REVEAL = 12
    const loadMore = document.querySelector(
      'section.retailers button#load-more-retailers'
    )

    const intialLoadHiddenItems = document.querySelectorAll(
      'section.retailers .item[hidden]'
    )

    if (intialLoadHiddenItems.length) {
      loadMore.hidden = false
    }

    loadMore.addEventListener('click', function () {
      const hiddenItems = [
        ...document.querySelectorAll('section.retailers .item[hidden]')
      ].slice(0, ITEMS_TO_REVEAL)

      hiddenItems.forEach((item) => (item.hidden = false))

      if (
        document.querySelectorAll('section.retailers .item[hidden]').length ===
        0
      ) {
        loadMore.hidden = true
      }
    })
  }
})()
